import { render, staticRenderFns } from "./UrlPayloadView.vue?vue&type=template&id=2b42cefe&scoped=true&"
import script from "./UrlPayloadView.vue?vue&type=script&lang=ts&"
export * from "./UrlPayloadView.vue?vue&type=script&lang=ts&"
import style0 from "./UrlPayloadView.vue?vue&type=style&index=0&id=2b42cefe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b42cefe",
  null
  
)

export default component.exports